import Modal from "react-modal";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { assetUrl, formatDate, formatDMy } from "../../utils/helpers";
import TourStatusBadge from "./TourStatusBadge";
import TourRequirementBadge from "./TourRequirementBadge";

export default function TourModal({ modalIsOpen, closeModal, tour }) {
  if(!tour) return null;

  const access = tour.access || {};
  const bannerSrc = tour.banner_image ? assetUrl + tour.banner_image : "/images/travel1.png";

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Tour Details"
    >
      <div className="My__Overlay">
        <div className="My__OverlayIn">
          <div className="modalTour popupcenter">
            <button
              className="modalClose d-flex align-items-center gap-1"
              onClick={closeModal}
              type="button"
            >
              <i className="fa-solid fa-xmark"></i>
            </button>

            <div className="travelInfo">
              <div className="TImg">
                <img
                  className="img-fluid w-100 imgradius"
                  src={bannerSrc}
                  alt={tour.title || "Tour"}
                />
                <TourStatusBadge access={access} />
                <TourRequirementBadge tour={tour} />
              </div>

              <div className="content">
                <div className="tourTitleRow">
                  <h4>{tour.title}</h4>
                </div>

                <div className="tourMeta">
                  <div className="tourMetaItem">
                    <span className="tourMetaIcon">
                      <i className="fa-regular fa-calendar"></i>
                    </span>
                    <div>
                      <small>Tour Month</small>
                      <strong>{formatDate(tour.tour_month_date)}</strong>
                    </div>
                  </div>
                </div>

                <div className="tourMeta">
                  <div className="tourMetaItem">
                    <span className="tourMetaIcon">
                      <i className="fa-solid fa-calendar-check"></i>
                    </span>
                    <div>
                      <small>Booking Till</small>
                      <strong>{formatDMy(tour.last_application_date)}</strong>
                    </div>
                  </div>
                </div>

                <div className="tourMeta">
                  <div className="tourMetaItem">
                    <span className="tourMetaIcon">
                      <i className="fa-solid fa-location-dot"></i>
                    </span>
                    <div>
                      <small>Location</small>
                      <strong>{tour.country || "-"} | by Trust Bitcoin</strong>
                    </div>
                  </div>
                </div>

                {!access.canOpenDocuments && access.reason && (
                  <div className="tourAccessInfo mt-4" role="status">
                    <div className="tourAccessInfoIcon">
                      <span>i</span>
                    </div>

                    <div className="tourAccessInfoContent">
                      <div className="tourAccessInfoTitle">
                        Tour Not Available
                      </div>

                      <div className="tourAccessInfoText">
                        {access.reason}
                      </div>
                    </div>
                  </div>
                )}

                <div className="d-flex justify-content-end flex-wrap gap-1 mt-3">
                  {access.canOpenDocuments && (
                    <Link
                      to={`/documents/${tour.slug}`}
                      state={{ tour }}
                      className="text-center mt-2 mybtn d-flex gap-2 align-items-center w-100 m-auto"
                    >
                      <span className="bgIN">
                        {access.canContinueApplication
                          ? "Manage Tour Bookings"
                          : "Redeem Your Travel Point"}
                      </span>
                    </Link>
                  )}

                  {access.canOpenDocuments && Number(tour.direct_team_validators || 0) > 0 && (
                    <button
                      type="button"
                      onClick={() =>
                        Swal.fire({
                          title: "Not Available Yet",
                          text: `This feature is not available for this ${tour.title || "tour"}. Please check back later.`,
                          icon: "warning",
                          showCancelButton: true,
                          showConfirmButton: false
                        })
                      }
                      className="text-center mt-2 mybtn d-flex gap-2 align-items-center w-100 m-auto"
                    >
                      <span className="bgIN">Book By Direct Team Count</span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}